import api from './api';

export const savedevices = async (payload) => {
    const response = await api.post('devices/saveList', payload);
    return response.data;
};


export const editdevice = async (payload) => {
    const response = await api.post('devices/editList', payload);
    return response.data;
};

export const getDeviceByUser = async (payload) => {
    const response = await api.post('devices/getDeviceByUser', payload);
    return response.data;
};

export const getMessageBydevice = async (payload) => {
    const response = await api.post('devices/getMessageBydevice', payload);
    return response.data;
};


export const savecontact = async (payload) => {
    const response = await api.post('contacts/saveList', payload);
    return response.data;
};

export const editcontact = async (payload) => {
    const response = await api.post('contacts/editList', payload);
    return response.data;
};

export const getContactsByUser = async (payload) => {
    const response = await api.post('contacts/getContactsByUser', payload);
    return response.data;
};



export const savecontactgroup = async (payload) => {
    const response = await api.post('contacts/savecontactgroup', payload);
    return response.data;
};

export const editcontactgroup = async (payload) => {
    const response = await api.post('contacts/editcontactgroup', payload);
    return response.data;
};

export const getContactGroupByUser = async (payload) => {
    const response = await api.post('contacts/getContactGroupByUser', payload);
    return response.data;
};


export const saveapps = async (payload) => {
    const response = await api.post('apps/saveList', payload);
    return response.data;
};

export const editapps = async (payload) => {
    const response = await api.post('apps/editList', payload);
    return response.data;
};

export const getappsByUser = async (payload) => {
    const response = await api.post('apps/getappsByUser', payload);
    return response.data;
};


export const getSubscriptionPlans = async (payload) => {
    const response = await api.post('subscriptions/getPlans', payload);
    return response.data;
};

export const subscribeToPlan = async (payload) => {
    const response = await api.post('subscriptions/subscribe', payload);
    return response.data;
};

export const saveSubscriptionPlan = async (payload) => {
    const response = await api.post('subscriptions/savePlan', payload);
    return response.data;
};

export const getUserStats = async (payload) => {
    const response = await api.post('subscriptions/getUserStats', payload);
    return response.data;
};

export const getMessageLogs = async (payload) => {
    const response = await api.post('subscriptions/getMessageLogs', payload);
    return response.data;
};

export const editUser = async (userData) => {
    const response = await api.post('users/editList', userData);
    return response.data;
};

  export const getUsers = async () => {
    const response = await api.get('users/getAll');
    return response.data;
  };

  export const getSubscriptionAnalytics = async () => {
    const response = await api.get('subscriptions/getSubscriptionAnalytics');
    return response.data;
  };

  export const getAdminDashboard = async () => {
    const response = await api.get('subscriptions/getAdminDashboard');
    return response.data;
  };



  export const checkUserLimits = async (userData) => {
    const response = await api.post('subscriptions/check_user_limit', userData);
    return response.data;
  };

  
export const savechatbot = async (payload) => {
    const response = await api.post('chatbot/saveList', payload);
    return response.data;
};

export const editchatbot = async (payload) => {
    const response = await api.post('chatbot/editList', payload);
    return response.data;
};


export const get_rules = async (payload) => {
    const response = await api.post('chatbot/get_rules', payload);
    return response.data;
};


export const deletechatbot = async (payload) => {
    const response = await api.post('chatbot/deleteList', payload);
    return response.data;
};




export const saveschedule = async (payload) => {
    const response = await api.post('chatbot/saveschedule', payload);
    return response.data;
};


export const deleteschedule = async (payload) => {
    const response = await api.post('chatbot/deleteschedule', payload);
    return response.data;
};
  
export const getScheduleByDevice = async (payload) => {
    const response = await api.post('chatbot/getScheduleByDevice', payload);
    return response.data;
};


export const verifyEmail = async (payload) => {
    const response = await api.post('users/verifyEmail', payload);
    return response.data
}

export const sendresetpasswordlink = async (payload) => {
    const response = await api.post('users/sendresetpasswordlink', payload);
    return response.data
}

export const resetpassword = async (payload) => {
    const response = await api.post('users/resetpassword', payload);
    return response.data
}



export const editwebhook = async (payload) => {
    const response = await api.post('users/editwebhook', payload);
    return response.data
}
export const deletewebhook = async (payload) => {
    const response = await api.post('users/deletewebhook', payload);
    return response.data
}
export const savewebhook = async (payload) => {
    const response = await api.post('users/savewebhook', payload);
    return response.data
}
export const getWebhookByUser = async (payload) => {
    const response = await api.post('users/getWebhookByUser', payload);
    return response.data
}


export const bulkUploadContacts = async (payload) => {
    const response = await api.post('contacts/saveBulkList', payload);
    return response.data
}


  
export const savesupport = async (payload) => {
    const response = await api.post('support/saveList', payload);
    return response.data;
};
export const getsupport = async (payload) => {
    const response = await api.post('support/getAll', payload);
    return response.data;
};


export const approveRequest = async (payload) => {
    const response = await api.post('subscriptions/approveRequest',payload);
    return response.data;
};
export const rejectRequest = async (payload) => {
    const response = await api.post('subscriptions/rejectRequest',payload);
    return response.data;
};
export const getSubscriptionRequests = async () => {
    const response = await api.get('subscriptions/getSubscriptionRequests');
    return response.data;
};

